import React, { FC } from 'react';
import { SvgLoader, SvgProxy } from 'react-svgmt';

interface SvgImageProps {
  color: string;
  source: string;
}

export const SvgImage: FC<SvgImageProps> = ({
  color,
  source,
  ...delegated
}) => {
  return (
    <SvgLoader path={source} {...delegated}>
      <SvgProxy selector="svg" fill={color} />
    </SvgLoader>
  );
};
